import { Injectable } from '@angular/core';
import { Environment, EnvironmentService, HttpService } from '@cloud-and-service/portal-lib';
import { ActivationTokenResult, ForgotPasswordResult, SetPasswordResult } from '../models/password-reset';

/** Anonymous activation link / forgot password endpoints. Business Central owns and validates the tokens. */
@Injectable({
  providedIn: 'root'
})
export class PasswordService {
  environment: Environment;

  constructor(
    private httpService: HttpService,
    environmentService: EnvironmentService
  ) {
    this.environment = environmentService.getEnvironment();
  }

  validateActivationToken(routePrefix: string, token: string, locale: string | null): Promise<ActivationTokenResult> {
    return this.httpService.post<ActivationTokenResult, any>(`${this.environment.apiUrl}/password/validate`, { routePrefix, token, locale });
  }

  setPassword(routePrefix: string, token: string, password: string): Promise<SetPasswordResult> {
    return this.httpService.post<SetPasswordResult, any>(`${this.environment.apiUrl}/password/set`, { routePrefix, token, password });
  }

  forgotPassword(routePrefix: string, userName: string): Promise<ForgotPasswordResult> {
    return this.httpService.post<ForgotPasswordResult, any>(`${this.environment.apiUrl}/password/forgot`, { routePrefix, userName });
  }
}
